<div class="additional-visitor">
    <sc-padding>
        <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">

            <div>
                <ng-container [formGroup]="masterdataForm">
                    <sc-flex>
                        <mat-form-field>
                            <input matInput name="name" formControlName="name"
                                placeholder="{{'Name' | translate: ['tmc-yard.entity.visit.name', translationService.language]}}"
                                [required]="true" minlength="row.minLength" maxlength="255">
                        </mat-form-field>
                        <sc-content-spacer [double]="true"></sc-content-spacer>
                        <mat-form-field>
                            <input matInput name="firstname" formControlName="firstname"
                                placeholder="{{'Firstname' | translate: ['tmc-yard.entity.visit.firstname', translationService.language]}}"
                                [required]="true" minlength="row.minLength" maxlength="255">
                        </mat-form-field>
                        <sc-content-spacer [double]="true"></sc-content-spacer>
                        <mat-form-field class="mail-field">
                            <input matInput name="mail" formControlName="mail"
                                placeholder="{{'Mail' | translate: ['tmc-yard.entity.visit.mail', translationService.language]}}"
                                [required]="true" minlength="row.minLength" maxlength="255">
                        </mat-form-field>
                        <sc-content-spacer [double]="true"></sc-content-spacer>
                        <button mat-flat-button (click)="inviteAdditionalVisitor()" [disabled]="!masterdataForm.valid">
                            {{'' | translate: ['tmc-yard.widgets.registration-terminal.visitor-additional-visitors.button.add', translationService.language]}}
                        </button>
                    </sc-flex>
                </ng-container>
            </div>

            <sc-content-spacer [vertical]="true" [double]="true"></sc-content-spacer>

            <b>{{'Bereits eingeladene Besucher2' | translate: ['tmc-yard.widgets.registration-terminal.visitor-additional-visitors.label.already-invited', translationService.language]}}</b>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
            <table>
                <thead>
                    <tr>
                    <td class="name">{{'Name' | translate: ['tmc-yard.entity.visit.name', translationService.language]}}</td>
                    <td class="firstname">{{'Firstname' | translate: ['tmc-yard.entity.visit.firstname', translationService.language]}}</td>
                    <td class="mail">{{'E-Mail' | translate: ['tmc-yard.entity.visit.mail', translationService.language]}}</td>
                    <td class="registrationCode">{{'RegistrationCode' | translate: ['tmc-visit.entity.visit.registrationCode', translationService.language]}}</td>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let entry of additionalVisitors">
                        <td class="name text-selection">{{entry.name}}</td>
                        <td class="firstname text-selection">{{entry.firstname}}</td>
                        <td class="mail text-selection">{{entry.mail}}</td>
                        <td class="registrationCode text-selection">{{entry.registrationCode}}</td>
                    </tr>
                </tbody>
            </table>

            <sc-content-spacer [vertical]="true" [grow]="true"></sc-content-spacer>

        </sc-flex>
    </sc-padding>
</div>